// One shared <body> scroll lock for every inline-style locker (ft-modal-overlay
// instances AND FtEnsureModalSingleScrollDirective hosts): stacked modals each take
// a reference; the inline style clears only when the last holder releases. Without
// the shared count, closing a stacked ft-modal-overlay wiped the directive's lock
// while its modal was still open (body scrollbar reappeared behind the modal).
let bodyScrollLocks = 0;

export function lockBodyScroll(): void {
    if (++bodyScrollLocks === 1) document.body.style.overflow = 'hidden';
}

export function unlockBodyScroll(): void {
    if (--bodyScrollLocks === 0) document.body.style.removeProperty('overflow');
}
